<template>
  <div>
    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-form @submit.prevent="save">
          <d-form-row>
            <!-- Nome -->
            <d-col md="6" class="form-group">
              <label for="name">Nome</label>
              <d-form-input
                id="name"
                type="text"
                v-model="model.name"
                :state="hasErrorField('name')"
                placeholder="Nome do equipamento"
                required
              />
              <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
            </d-col>

            <!-- Categoria -->
            <d-col md="6" class="form-group">
              <label for="category_id">Categoria</label>
              <div class="d-flex">
                <d-select
                  id="category_id"
                  v-model="model.category_id"
                  :options="categories"
                  value-field="id"
                  text-field="name"
                  class="flex-grow-1"
                >
                  <option :value="null">Selecione uma categoria</option>
                </d-select>
                <d-button
                  type="button"
                  variant="outline-primary"
                  size="sm"
                  class="ml-2"
                  @click="openCategoryModal"
                  title="Nova categoria"
                >
                  <i class="fas fa-plus"></i>
                </d-button>
              </div>
            </d-col>
          </d-form-row>

          <d-form-row>
            <!-- Número de Série -->
            <d-col md="4" class="form-group">
              <label for="serial_number">Número de Série</label>
              <d-form-input
                id="serial_number"
                type="text"
                v-model="model.serial_number"
                placeholder="Número de série do equipamento"
              />
            </d-col>

            <!-- Certificado de Calibração -->
            <d-col md="4" class="form-group">
              <label for="calibration_certificate">Certificado de Calibração</label>
              <d-form-input
                id="calibration_certificate"
                type="text"
                v-model="model.calibration_certificate"
                placeholder="Certificado de calibração"
              />
            </d-col>

            <!-- Data de Validade -->
            <d-col md="4" class="form-group">
              <label for="expiration_date">Data de Validade</label>
              <datepicker :model.sync="model.expiration_date"/>
            </d-col>
          </d-form-row>

          <d-button type="submit" class="btn-accent">Salvar</d-button>
        </d-form>
      </d-list-group-item>
    </d-list-group>

    <!-- Modal de Categoria -->
    <equipment-category-modal ref="categoryModal" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import EquipmentService from '_services/rest/modules/equipment';
import MixinValidateForm from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import { getDateTimeISO } from '_utils';
import { MODEL, _LOAD_MODEL_, _SAVE_EQUIPMENT_SUCCESS_, CATEGORY_MODEL, _LOAD_EQUIPMENT_CATEGORY_, _RELOAD_EQUIPMENT_CATEGORY_ } from './EquipmentModel';
import EquipmentCategoryModal from './modal/EquipmentCategoryModal.vue';

export default {
  name: 'equipment-form',
  mixins: [MixinValidateForm, formatErrors],
  components: {
    Datepicker,
    EquipmentCategoryModal,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
      },
    };
  },
  computed: {
    categories() {
      const { equipmentCategories } = this.$store.state.equipment;
      if (equipmentCategories && equipmentCategories.length) {
        return equipmentCategories;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getEquipmentCategories',
    ]),
    checkForm() {
      this.errors.name.required = !this.model.name;
      return !this.errors.name.required;
    },
    getOptions() {
      if (!this.$store.state.equipment.equipmentCategories) {
        this.setToggle({ type: 'progress', bool: true });
        this.getEquipmentCategories()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    openCategoryModal() {
      Events.$emit(_LOAD_EQUIPMENT_CATEGORY_, CATEGORY_MODEL);
      this.setToggle({ type: 'add_equipment_category_modal', bool: true });
    },
    save() {
      if (this.checkForm()) {
        this.toggleLoading();

        if (this.model.expiration_date) {
          this.model.expiration_date = getDateTimeISO(this.model.expiration_date);
        }

        EquipmentService.save(this.model)
          .then(response => this.success(response))
          .catch(error => {
            this.toggleLoading();
            this.showError(error);
          });
      }
      return null;
    },
    success(equipment) {
      this.model = equipment;
      this.$store.commit('setEquipment', equipment);
      this.toggleLoading();
      this.activeAlert({ message: 'Equipamento salvo com sucesso', theme: 'success' });
      Events.$emit(_SAVE_EQUIPMENT_SUCCESS_, equipment);

      if (!this.$route.params.equipmentId) {
        this.$router.push(`/admin/equipamentos/${equipment.id}`);
      }
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = newValue;
    });
    Events.$on(_RELOAD_EQUIPMENT_CATEGORY_, () => {
      this.getEquipmentCategories();
    });
    this.getOptions();
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_);
    Events.$off(_RELOAD_EQUIPMENT_CATEGORY_);
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
}
</style>
